export default "__VITE_ASSET__BA_bkoyo__"